import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import AdminLogin from '../pages/AdminLogin';
import AdminLayout from '../components/AdminLayout';
import Dashboard from '../pages/Dashboard';
import Properties from '../pages/Properties';
import AddProperty from '../pages/AddProperty';
import EditProperty from '../pages/EditProperty';
import Settings from '../pages/Settings';
import ViewProperties from '../pages/ViewProperties';
import Customers from '../pages/Customers';

const ErrorElement = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-prose-brand mb-4">404</h1>
      <p className="text-prose-black/60 mb-8">Page not found</p>
      <a href="/" className="bg-prose-brand text-white px-6 py-2 rounded-lg hover:bg-prose-brand/80">
        Go to Dashboard
      </a>
    </div>
  </div>
);

export const router = createBrowserRouter([
  {
    path: '/admin-login',
    element: <AdminLogin />,
    errorElement: <ErrorElement />,
  },
  {
    path: '/login',
    element: <Navigate to="/admin-login" replace />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorElement />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'properties',
        element: <Properties />,
      },
      {
        path: 'customers',
        element: <Customers />,
      },
      {
        path: 'properties/add',
        element: <AddProperty />,
      },
      {
        path: 'properties/:id/edit',
        element: <EditProperty />,
      },
      {
        path: 'properties/:id',
        element: <ViewProperties />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
    ],
  },
  {
    path: '*',
    element: <ErrorElement />,
  },
]);
